import styled from "styled-components";

export const QuotationsWrapper = styled.div``;
export const ViewQuotationWrapper = styled.div`
  .table-wrapper {
    background-color: var(--white) !important;
    padding: 20px !important;
    margin: 20px !important;
    border-radius: 15px;
  }
  .sub-title-wrapper {
    width: 40%;
    @media (max-width: 560px) {
      width: 100%;
    }
  }
  /* .info-wrapper {
    width: 40%;
    @media (max-width: 560px) {
      width: 100%;
    }
  } */
  .footer-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    gap: 80px;
    margin-block: 25px;
  }
`;
